import queryString from 'query-string'
import axios, { uploadAxios } from './requestInterceptor'
import { IErrorCallback, IGetUploadedFile, ISuccessCallback, IUploadVideoFile } from './types'

export async function uploadFile(
  userId: string | undefined,
  data: any,
  successCallback: ISuccessCallback,
  errorCallback: IErrorCallback
) {
  await uploadAxios
    .post(`/users/${userId}/upload/`, data)
    .then((response) => {
      successCallback(response.data)
    })
    .catch((error) => {
      errorCallback(error)
    })
}

export async function uploadVideoFile(
  userId: string | undefined,
  data: IUploadVideoFile,
  successCallback: ISuccessCallback,
  errorCallback: IErrorCallback
) {
  await axios
    .post(`/users/${userId}/upload/video`, data, { withCredentials: true })
    .then((response) => successCallback(response.data))
    .catch(errorCallback)
}

export async function uploadedFileFilter(
  userId: string | undefined,
  data: any,
  successCallback: ISuccessCallback,
  errorCallback: IErrorCallback
) {
  await axios
    .get(`/users/${userId}/upload/filters`, {
      params: data
    })
    .then((response) => {
      successCallback(response.data.data)
    })
    .catch((error) => {
      errorCallback(error)
    })
}

export async function getUploadedFile(
  userId: string | undefined,
  data: IGetUploadedFile,
  successCallback: ISuccessCallback,
  errorCallback: IErrorCallback
) {
  await axios
    .get(`/users/${userId}/upload/`, {
      params: data,
      paramsSerializer: function (params) {
        return queryString.stringify(params)
      }
    })
    .then((response) => {
      successCallback(response.data)
    })
    .catch((error) => {
      errorCallback(error)
    })
}
